export const basePath = process.env.REACT_APP_API_CONNECTION;
export const apiVersion = "v1";
export const ACCESS_TOKEN = "accessToken";
export const REFRESH_TOKEN = "refreshToken";
export const version = "1.6.4";